import { Injectable, inject } from '@angular/core';
import { Observable, map, timeout } from 'rxjs';
import { AppService } from '../app.service';
import { NotificationItem } from './notification.model';
import { normalizeLegacyRest, uniqueNotifications } from './notification-normalizers';

/** Mantiene endpoint e autenticazione del legacy; converte soltanto il contratto. */
@Injectable({ providedIn: 'root' })
export class LegacyNotificationsAdapter {
  private readonly app = inject(AppService);

  list(): Observable<readonly NotificationItem[]> {
    return this.app.getUserAlerts().pipe(
      timeout(30_000),
      map((rows: unknown) => {
        if (!Array.isArray(rows)) throw new Error('Invalid legacy inbox response');
        return uniqueNotifications(rows.map(normalizeLegacyRest).filter((row): row is NotificationItem => row !== null));
      }),
    );
  }

  markRead(id: number): Observable<void> {
    return this.app.updateAsRead(id).pipe(timeout(30_000), map(() => undefined));
  }

  remove(id: number): Observable<void> {
    return this.app.deleteAlert(id).pipe(timeout(30_000), map(() => undefined));
  }
}
